<template>
  <div class="message-board-page page">
    <div class="page-header">
      <div class="page-title">News board</div>
    </div>

    <div class="main-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div
          v-for="(item, index) in displayMessages"
          :key="item.id || index"
          class="message-item"
        >
          <div class="message-date">{{ item.date }}</div>
          <div class="message-id">{{ item.code }}</div>
          <div class="message-content">{{ item.content }}</div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
const fallbackMessages = [
  {
    create_time: "2025-12-02 00:00:00",
    name: "130",
    text: "The service after the upgrade is great. I can date girls nearby anytime and have sex, which gives me a different pleasure every time.",
  },
  {
    create_time: "2025-11-30 00:00:00",
    name: "129",
    text: "The girls inside are really pretty.",
  },
  {
    create_time: "2025-11-30 00:00:00",
    name: "128",
    text: "The one-night-stand matching here is really strong. This is the fifth girl I've met.",
  },
  {
    create_time: "2025-11-30 00:00:00",
    name: "127",
    text: "This is wonderful! Why did I only discover how interesting this platform is now?",
  },
  {
    create_time: "2025-11-29 00:00:00",
    name: "126",
    text: "I had a great date thanks to the platform, and next time I'll go out with someone new.",
  },
  {
    create_time: "2025-11-29 00:00:00",
    name: "125",
    text: "Wow, I was a little skeptical when I first came to this platform! I never expected to meet my true love on my first date. Thank you, platform!",
  },
  {
    create_time: "2025-11-28 00:00:00",
    name: "124",
    text: "This was my first date here, and I met my soulmate. After we met, he was very gentle, considerate, and kind to me. I like him very much.",
  },
  {
    create_time: "2025-11-27 00:00:00",
    name: "123",
    text: "Oh my God, it's my first time coming here for a date, and I didn't expect it to be this exciting. Yesterday I thought it wasn't real, but today I actually met the person I'm interested in. We spent time together doing whatever we wanted.",
  },
  {
    create_time: "2025-11-27 00:00:00",
    name: "122",
    text: "I never thought I would come across such a great website. The girls here are amazing and the experience is really good.",
  },
  {
    create_time: "2025-11-26 00:00:00",
    name: "121",
    text: "The atmosphere here is great and really fun. The girls I meet here are all wonderful and interesting.",
  },
  {
    create_time: "2025-11-26 00:00:00",
    name: "120",
    text: "This place is pretty cool! The vibe is great, and everyone I've met so far has been really chill.",
  },
  {
    create_time: "2025-11-26 00:00:00",
    name: "119",
    text: "Gotta say, this spot is top-notch! The people here are amazing, and the girls are all really cool.",
  },
  {
    create_time: "2025-11-25 00:00:00",
    name: "118",
    text: "Honestly, this site is pretty great. The people are cool, and it's super easy to find what you're looking for. Definitely better than other sites I've tried.",
  },
  {
    create_time: "2025-11-25 00:00:00",
    name: "117",
    text: "The dating platform is a little naughty. I can't help but sneak a peek at the cute little kitten here.",
  },
  {
    create_time: "2025-11-24 00:00:00",
    name: "116",
    text: "I think the social experience here is great, safe, and efficient, making it very convenient to make friends. I also successfully met my partner and experienced a romantic encounter.",
  },
  {
    create_time: "2025-11-24 00:00:00",
    name: "115",
    text: "Today was the best experience I've ever had. I'm truly grateful to this platform for bringing me joy.",
  },
  {
    create_time: "2025-11-23 00:00:00",
    name: "114",
    text: "Wow. Dating here feels amazing, it's a feeling I've never experienced before.",
  },
  {
    create_time: "2025-11-23 00:00:00",
    name: "113",
    text: "I never thought I would fall in love again at this age.",
  },
  {
    create_time: "2025-11-23 00:00:00",
    name: "112",
    text: "My date was amazing. I really like her a lot.",
  },
  {
    create_time: "2025-11-22 00:00:00",
    name: "111",
    text: "I didn't know there was such an interesting community in this world. I am very happy.",
  },
  {
    create_time: "2025-10-19 00:00:00",
    name: "110",
    text: "I really enjoyed choosing a lady here today and going on a date with her.",
  },
  {
    create_time: "2025-09-19 00:00:00",
    name: "109",
    text: "It was only after I came into contact with the club that I realized there was such a wonderful thing. Dating and having sex with girls can be so exciting.",
  },
  {
    create_time: "2025-09-19 00:00:00",
    name: "108",
    text: "When I came here, I realized that dating girls is really fun. Girls are very considerate and helpful.",
  },
  {
    create_time: "2025-09-18 00:00:00",
    name: "107",
    text: "Thanks to this dating platform, my beloved lady and I are getting married next month.",
  },
  {
    create_time: "2025-09-17 00:00:00",
    name: "106",
    text: "The lady here is really nice. I'll come again next time.",
  },
];

export default {
  name: "MessageBoard",
  data() {
    return {
      isLoading: false,
      messages: [],
    };
  },
  computed: {
    displayMessages() {
      const source = this.messages.length ? this.messages : fallbackMessages;
      return source.map((item, index) => ({
        id: item.id || index + 1,
        date: this.formatDate(item.create_time),
        code: this.formatCode(item, index),
        content: item.text || item.content || "",
      }));
    },
  },
  methods: {
    getMessageList() {
      this.$http({
        method: "get",
        url: "sys_get_msg_list",
      }).then((res) => {
        this.messages = Array.isArray(res.data) ? res.data : [];
      });
    },
    onRefresh() {
      this.getMessageList();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    formatDate(value) {
      if (!value) {
        return "11/30/2025";
      }

      const datePart = String(value).split(" ")[0];
      const parts = datePart.split("-");

      if (parts.length === 3) {
        return `${parts[1]}/${parts[2]}/${parts[0]}`;
      }

      return datePart;
    },
    formatCode(item, index) {
      if (item.name) {
        return item.name;
      }

      if (item.id) {
        return String(item.id);
      }

      return String(130 - index);
    },
  },
  created() {
    this.getMessageList();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.message-board-page {
  min-height: 100%;
  background: #fff;
}

.page-header {
  height: 128px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 2px solid #efefef;
}

.page-title {
  color: #000;
  font-size: 34px;
  line-height: 44px;
  font-weight: 500;
}

.main-content {
  padding: 28px 24px 160px;
  background: #fff;
}

.message-item {
  margin-bottom: 20px;
  padding: 20px 18px 24px;
  border: 2px solid #dddddd;
  border-radius: 12px;
  background: #fff;
}

.message-date {
  color: #111;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}

.message-id {
  margin-top: 10px;
  color: #8c8c8c;
  font-size: 26px;
  line-height: 34px;
}

.message-content {
  margin-top: 18px;
  color: #111;
  font-size: 22px;
  line-height: 34px;
  font-weight: 600;
  word-break: break-word;
}

::v-deep .van-pull-refresh__track {
  min-height: calc(100vh - 230px);
}

::v-deep .van-pull-refresh__head * {
  color: #000;
  font-size: 28px;
}
</style>
